import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initSentry } from "./config/sentry";
import { ErrorBoundary } from "@sentry/react";

// Initialize Sentry before rendering the app
initSentry();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary
      fallback={({ error, resetError }) => (
        <div>
          <h2>Something went wrong:</h2>
          <details style={{ whiteSpace: "pre-wrap" }}>
            {error ? String(error) : "Unknown error"}
          </details>
          <button onClick={resetError}>Try again</button>
        </div>
      )}
    >
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
